import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
// modules
import app from './modules/app';
import setting from './modules/setting';
import ua from './modules/ua';
import member from './modules/member';
import warehouse from './modules/warehouse';
import ad from './modules/ad';
import information from './modules/information';
import website from './modules/website';
import share from './modules/share';
import parcel from './modules/parcel';
import service from './modules/service';
import balance from './modules/balance';
import order from './modules/order';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    app,
    setting,
    ad,
    ua,
    member,
    warehouse,
    information,
    website,
    share,
    parcel,
    service,
    balance,
    order,
  },
  strict: true,
  plugins: debug ? [createLogger()] : [],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js